import { ReactNode } from "react";
import { useAuthStore } from "@/stores/authStore";
import { LogOut } from "lucide-react";

interface ClientLayoutProps {
  children: ReactNode;
}

export default function ClientLayout({ children }: ClientLayoutProps) {
  const { user, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    window.location.href = "/login";
  };

  return (
    <div className="min-h-screen bg-dark">
      <header className="h-16 bg-bg-secondary/60 backdrop-blur-xl border-b border-white/10 flex items-center justify-between px-4 sm:px-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center text-primary font-bold">
            {user?.name?.charAt(0).toUpperCase() || "C"}
          </div>
          <div>
            <p className="text-text-primary font-semibold">Portal do Cliente</p>
            <p className="text-xs text-text-muted">{user?.email}</p>
          </div>
        </div>
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 text-red-400 hover:text-red-300 transition-colors"
        >
          <LogOut className="w-4 h-4" />
          <span className="text-sm">Sair</span>
        </button>
      </header>
      <main className="p-4 sm:p-6">{children}</main>
    </div>
  );
}
